import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { getCurrentToken } from "./tokenFetcher";
import { msalConfig, loginRequest } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

export function initializeMsal() {
  console.log("=> msal initialization..");
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  // const accounts = msalInstance.getAllAccounts();
  // if (accounts.length > 0) {
  //   msalInstance.setActiveAccount(accounts[0]);
  // }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  // Listen for sign-in event and set active account
  msalInstance.addEventCallback(async (event: any) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });
}

export async function getToken() {
  const authToken = await getCurrentToken(msalInstance);
  console.log("AUTH TOKEN:", authToken);

  return authToken;
}

// Login through a sign-in button
export const handleLogin = (loginType = "redirect") => {
  if (loginType === "popup") {
    msalInstance.loginPopup(loginRequest).catch((e: any) => {
      console.error(`loginPopup failed: ${e}`);
    });
  } else if (loginType === "redirect") {
    msalInstance.loginRedirect(loginRequest).catch((e: any) => {
      console.error(`loginRedirect failed: ${e}`);
    });
  }
};

// Logout through a logout button
export const handleLogout = (logoutType = "redirect") => {
  if (logoutType === "popup") {
    msalInstance.logoutPopup().catch((e: any) => {
      console.error(`logoutPopup failed: ${e}`);
    });
  } else if (logoutType === "redirect") {
    const logoutRequest = {
      account: msalInstance.getActiveAccount(),
      postLogoutRedirectUri: process.env.NEXT_PUBLIC_REDIRECT_URI,
    };
    msalInstance.logoutRedirect(logoutRequest).catch((e: any) => {
      console.error(`logoutRedirect failed: ${e}`);
    });
  }
};